module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch01.htm#c01"
    }
  }, [_c('em', [_vm._v("Diary Entries")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "epi"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/epil.htm#epi"
    }
  }, [_c('em', [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "his"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/his.htm#his"
    }
  }, [_c('em', [_vm._v("Historical Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "bk"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/bk.htm"
    }
  }, [_c('em', [_vm._v("Images and Documents")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ack.htm#ack"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "ded"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ded.htm"
    }
  }, [_c('em', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "ata"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ata.htm#ata"
    }
  }, [_c('em', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/copy.htm"
    }
  }, [_c('em', [_vm._v("Copyright Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "bm"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/bm.htm"
    }
  }, [_c('em', [_vm._v("Books in the Dear Canada Series")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 60
// module chunks = 0